/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export { BrowserModule, platformBrowser } from "./browser";
export { Meta } from "./browser/meta";
export { Title } from "./browser/title";
export { disableDebugTools, enableDebugTools } from "./browser/tools/tools";
export { BrowserTransferStateModule, TransferState, makeStateKey } from "./browser/transfer_state";
export { By } from "./dom/debug/by";
export { DOCUMENT } from "./dom/dom_tokens";
export { EVENT_MANAGER_PLUGINS, EventManager } from "./dom/events/event_manager";
export { HAMMER_GESTURE_CONFIG, HammerGestureConfig } from "./dom/events/hammer_gestures";
export { DomSanitizer } from "./security/dom_sanitization_service";
export { ɵBROWSER_SANITIZATION_PROVIDERS, ɵINTERNAL_BROWSER_PLATFORM_PROVIDERS, ɵinitDomAdapter, ɵBrowserDomAdapter, ɵBrowserPlatformLocation, ɵTRANSITION_ID, ɵBrowserGetTestability, ɵescapeHtml, ɵELEMENT_PROBE_PROVIDERS, ɵDomAdapter, ɵgetDOM, ɵsetRootDomAdapter, ɵDomRendererFactory2, ɵNAMESPACE_URIS, ɵflattenStyles, ɵshimContentAttribute, ɵshimHostAttribute, ɵDomEventsPlugin, ɵHammerGesturesPlugin, ɵKeyEventsPlugin, ɵDomSharedStylesHost, ɵSharedStylesHost } from "./private_export";
export { VERSION } from "./version";
//# sourceMappingURL=platform-browser.js.map


// WEBPACK FOOTER //
// ../../../packages/platform-browser/esm5/src/platform-browser.js